import React from 'react';
import {
  useFormContext,
  Controller,
  FieldErrorsImpl,
  DeepRequired,
  FieldValues
} from 'react-hook-form';
import { createStyles, makeStyles, TextField, Theme } from '@material-ui/core';
import { isTodayAfter } from '../../../utils/common';
import { validationMessage } from '../../../const/ProcessConst';

type TProps = {
  name: any;
  label?: string;
  defaultValue?: string;
  // errorMessage?: FieldErrorsImpl<DeepRequired<FieldValues>> | string | undefined,
  errorMessage?: React.ReactNode;
  style?: any;
  required?: boolean;
  fullWidth?: boolean;
  onChange?: any;
  fromDate?: string;
  toDate?: string;
};

export const AppDatePicker: React.VFC<TProps> = React.memo((props: TProps) => {
  const classes = useStyles();

  // react-hook-fomrを使用する前提のcomponent
  const { register, control } = useFormContext();
  const height = 34;

  // https://mui.com/components/text-fields/#main-content の必要なpropsを追加する
  const {
    name,
    label,
    defaultValue,
    errorMessage,
    style,
    required = false,
    fullWidth = false,
    onChange,
    fromDate,
    toDate
  } = props;

  // 共有期限の入力の場合にバリデーションを有効にするフラグ
  // ※React Hook Formのvalidateはfalse不可のため、undefinedにしている
  const isValidation = name.includes('expiration_at') ? true : undefined;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...register(name, {
            required: required,
            min: fromDate && {
              // fromDateがpropsにある場合にバリデーション有効
              value: fromDate,
              message: validationMessage.dateFromTo
            },
            max: toDate && {
              // toDateがpropsにある場合にバリデーション有効
              value: toDate,
              message: validationMessage.dateFromTo
            },
            validate: {
              expirationAt: inputDate =>
                (isValidation ? isTodayAfter(inputDate) : true) ||
                '共有期限は本日以降で設定してください。'
            }
          })}
          type='date'
          fullWidth={fullWidth}
          defaultValue={defaultValue}
          className={classes.textField}
          error={errorMessage !== undefined} // errorMessageがあればエラーのスタイルを適用
          helperText={errorMessage}
          variant='outlined'
          placeholder={label}
          style={style}
          inputProps={{
            style: {
              height,
              padding: '0 14px'
            }
          }}
          onChange={onChange}
        />
      )}
    />
  );
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      backgroundColor: 'white'
    }
  })
);
